'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var qwest = _interopRequireWildcard(require("qwest"));
var _moment = _interopRequireDefault(require("moment"));
var _Table = _interopRequireDefault(require("@material-ui/core/Table"));
var _TableBody = _interopRequireDefault(require("@material-ui/core/TableBody"));
var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));
var _TablePagination = _interopRequireDefault(require("@material-ui/core/TablePagination"));
var _TableRow = _interopRequireDefault(require("@material-ui/core/TableRow"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));
var _EnhancedTableHead = _interopRequireDefault(require("Components/Lists/EnhancedTableHead"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _DeleteSectorModal = _interopRequireDefault(require("Modals/DeleteSectorModal"));
var _Link = _interopRequireDefault(require("Pure/Link"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
_moment.default.locale('fr');
let app = window.app;
class Sectors extends _react.Component {
  state = {
    loading: false,
    openDeleteSectorModal: false,
    selected: [],
    sectors: [],
    sectors_count: 0,
    page: 0,
    rows_per_page: 25,
    order: 'asc',
    order_by: 'name'
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchSectors({});
  }
  fetchSectors = _ref => {
    let {
      page,
      order,
      order_by
    } = _ref;
    const component = this,
      props = this.props,
      state = this.state;
    page = typeof page === 'undefined' ? state.page : page;
    order = order || state.order;
    order_by = order_by || state.order_by;
    component.setState({
      loading: true
    });
    qwest.post('/sector/get-all', {
      limit: state.rows_per_page,
      skip: state.rows_per_page * page,
      with_count: true,
      order: order,
      order_by: order_by
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        sectors: response.sectors,
        sectors_count: response.count
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  openDeleteSectorModal = _ref2 => {
    let {
      sector_id,
      e
    } = _ref2;
    const component = this,
      props = this.props,
      state = this.state;
    e.persist();
    component.setState({
      openDeleteSectorModal: true,
      delete_modal_sector: sector_id,
      delete_modal_trigger: e.target
    });
  };
  closeDeleteSectorModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      openDeleteSectorModal: false,
      delete_modal_sector: undefined,
      delete_modal_trigger: undefined
    });
    component.fetchSectors({});
  };
  handleChangePage = (e, page) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      page: page
    });
    component.fetchSectors({
      page: page
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const empty_rows = state.rows_per_page - Math.min(state.rows, state.sectors_count - state.page * state.rows_per_page);
    _moment.default.locale('fr');
    const rows = (state.sectors || []).map(function (data) {
      const link = /*#__PURE__*/_react.default.createElement(_Link.default, {
        href: '/configuration/liste-des-secteurs/' + data.id,
        className: "u-link-only"
      });
      const departments = (data.department || []).map(function (department) {
        let output = /*#__PURE__*/_react.default.createElement("span", {
          className: "u-padding-right-5"
        }, department);
        return output;
      });
      let output = /*#__PURE__*/_react.default.createElement(_TableRow.default, {
        hover: true,
        tabIndex: -1,
        key: data.id
      }, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, data.name, link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, departments, link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        variant: "text",
        color: "secondary",
        onClick: e => component.openDeleteSectorModal({
          sector_id: data.id,
          e: e
        })
      }, /*#__PURE__*/_react.default.createElement(_Delete.default, {
        color: "secondary"
      }))));
      return output;
    });
    const columns = [{
      id: 'name',
      numeric: false,
      label: 'Nom du secteur',
      center: true,
      sortable: false
    }, {
      id: 'departments',
      numeric: false,
      label: 'Départements',
      center: true,
      sortable: false
    }, {
      id: 'actions',
      numeric: false,
      label: '',
      center: true,
      sortable: false
    }];
    let output = /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "dashboard-table"
    }, /*#__PURE__*/_react.default.createElement(_Table.default, {
      "aria-labelledby": "Secteurs"
    }, /*#__PURE__*/_react.default.createElement(_EnhancedTableHead.default, {
      onRequestSort: component.handleRequestSort,
      order: state.order,
      order_by: state.order_by,
      row_count: rows.length,
      columns: columns
    }), /*#__PURE__*/_react.default.createElement(_TableBody.default, null, rows, empty_rows > 0 ? /*#__PURE__*/_react.default.createElement(_TableRow.default, {
      style: {
        height: 49 * empty_rows
      }
    }, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      colSpan: 4
    })) : undefined)), /*#__PURE__*/_react.default.createElement(_TablePagination.default, {
      onChangePage: component.handleChangePage,
      component: "div",
      count: state.sectors_count,
      rowsPerPage: state.rows_per_page,
      rowsPerPageOptions: [],
      page: state.page,
      backIconButtonProps: {
        'aria-label': 'Page précédente'
      },
      nextIconButtonProps: {
        'aria-label': 'Page suivante'
      },
      labelDisplayedRows: _ref3 => {
        let {
          from,
          to,
          count
        } = _ref3;
        return from + '-' + to + ' sur ' + count;
      }
    }), /*#__PURE__*/_react.default.createElement(_DeleteSectorModal.default, {
      sector_to_delete: state.delete_modal_sector,
      open: state.openDeleteSectorModal,
      onClose: component.closeDeleteSectorModal,
      delete_modal_trigger: state.delete_modal_trigger
    }));
    return output;
  }
}
exports.default = Sectors;
